export const menus = [
  {
    label: "Home",
    link: "/",
  },
  {
    label: "Productos",
    link: "/productos/"
  },
  {
    label: "Nosotros",
    link: "/nosotros/"
  },
  {
    label: "Contacto",
    link: "/contacto/"
  },
];
